import type { SummaryDocumentMetrics, ThrowMetrics } from '~/types/throwMetrics'
import { advanceRatio, feetToMeters, mphToKph, mul } from '~/utils/math'

export const generateThrowSummaryMetrics = (metrics: SummaryDocumentMetrics): ThrowMetrics => {
    return {
        speedMph: metrics?.speedMph,
        speedKmh: mphToKph(metrics?.speedMph ?? 0),
        spinRpm: Math.abs(mul(metrics?.rotPerSec ?? 0, 60).toNumber()),
        hyzerAngle: metrics?.correctedHyzerAngle ?? metrics?.hyzerAngle,
        noseAngle: metrics?.correctedNoseAngle ?? metrics?.noseAngle,
        advanceRatio: advanceRatio(metrics?.rotPerSec ?? 0, metrics?.speedMph ?? 0),
        launchAngle: metrics?.uphillAngle,
        wobble: metrics?.offAxisDegrees,
        distanceFeet: metrics?.estimatedFeet ?? 0,
        distanceMeters: feetToMeters(metrics?.estimatedFeet ?? 0),
        flightNumbers: metrics?.estimatedFlightNumbers,
    }
}
